import { CircularProgress, Typography } from '@mui/material'
import { useAuth } from 'hooks'
import { Link } from 'react-router-dom'
import { clientes } from 'service/api'

export default function AtendimentoOnline() {
    const {
        decoded: { cliente: clienteId },
    } = useAuth()
    const { data, isFetched } = clientes.useFetchById(clienteId)
    const Representante = (data as any)?.Criador?.Cliente
    const { data: data_representante, isFetched: isRepresentanteFetched } =
        clientes.useFetchById(Representante?.id, { enabled: !!Representante })

    if (!isFetched || (!!Representante && !isRepresentanteFetched))
        return (
            <div className="flex justify-center items-center h-screen -mt-16">
                <CircularProgress className="size-24!" />
            </div>
        )

    if (Representante && data?.suporteIntegrado === 'N') {
        const nome =
                data_representante?.nomeContato ??
                data_representante?.nomeFantasia,
            email = String(
                data_representante?.emailContato ??
                    (data as any)?.Criador?.email ??
                    '',
            ).trim(),
            telefone = String(
                data_representante?.telefoneContato ??
                    Representante.telefoneResponsavel ??
                    '',
            ).replace(/\D/g, '')

        return (
            <div className="flex flex-col sm:flex-row justify-center items-center gap-4 sm:gap-8 p-4 w-screen h-screen -mt-16">
                <div className="flex flex-col ">
                    <span className="text-3xl font-bold">
                        Precisa de ajuda?
                    </span>
                    <span className="text-xl font-semibold">
                        Entre em contato com seu representante
                    </span>
                </div>
                <div className="flex flex-col gap-2 sm:gap-4 border-l pl-4 sm:pl-8">
                    <h6 className="text-2xl font-semibold">{nome}</h6>
                    {!!email && (
                        <Typography
                            variant="body1"
                            sx={{ fontSize: '1.2rem' }}
                            title="Clique para criar um rascunho de email"
                        >
                            <Link
                                to={`mailto:${email}`}
                                target="_blank"
                                rel="noreferrer noopener"
                            >
                                {email}
                            </Link>
                        </Typography>
                    )}
                    {!!telefone && (
                        <Typography
                            variant="body1"
                            sx={{ fontSize: '1.2rem' }}
                            title="Clique para enviar uma mensagem no WhatsApp"
                        >
                            <Link
                                to={`https://api.whatsapp.com/send?phone=55${telefone}`}
                                target="_blank"
                                rel="noreferrer noopener"
                            >
                                {telefone}
                            </Link>
                        </Typography>
                    )}
                </div>
            </div>
        )
    }

    return window.location.replace(
        'https://cliente.farolsoftware.com.br/atendimento',
    ) as any
}
